import { render, staticRenderFns } from "./EditForm.vue?vue&type=template&id=ffbd28fc&scoped=true"
import script from "./EditForm.vue?vue&type=script&lang=js"
export * from "./EditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffbd28fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ffbd28fc')) {
      api.createRecord('ffbd28fc', component.options)
    } else {
      api.reload('ffbd28fc', component.options)
    }
    module.hot.accept("./EditForm.vue?vue&type=template&id=ffbd28fc&scoped=true", function () {
      api.rerender('ffbd28fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/commonPage/components/EditForm.vue"
export default component.exports